export const HEADERS_REEMA_IMPERSONATION_USER_ID =
  'x-reema-impersonation-user-id';
